import { gql, useMutation } from '@apollo/client'
import { FETCH_SESSION_SUPPLIERS } from '@/gf/queries/session'
import FETCH_ALL_STORES from '@/gf/queries/suppliers'
import { Store } from '../../types'

interface Vars {
  storeId: string
}

interface Data {
  sendEnableGearflowPaymentsEmail: Store
}

const doc = gql`
  mutation SendEnableGearflowPaymentsEmail($storeId: String!) {
    sendEnableGearflowPaymentsEmail(storeId: $storeId) {
      id
    }
  }
`

const useSendEnableGearflowPaymentsEmail = () =>
  useMutation<Data, Vars>(doc, { refetchQueries: [FETCH_ALL_STORES, FETCH_SESSION_SUPPLIERS] })

export default useSendEnableGearflowPaymentsEmail
